/**
 * Query keys do domínio WhatsApp (CRM): config do canal por clube e o QR code
 * do pareamento do gateway (conexão por QR, aparelho vinculado).
 *
 * `configAll` invalida a config de TODOS os clubes por prefix-match — é o que
 * as mutations de conectar/desconectar usam, porque o diálogo pode estar
 * aberto para outro clube da rede. O QR fica FORA desse prefixo de propósito:
 * invalidar a config não deve disparar uma leitura extra do QR no meio do
 * pareamento (o polling dele tem ritmo próprio).
 */
import { tuple } from "./core";

const root = ["whatsapp"] as const;
const config = tuple(root, "config");

export const whatsapp = {
  all: root,
  /** Prefixo da config de todos os clubes (invalidação). */
  configAll: config,
  /** `club_whatsapp_config` de um clube. */
  config: (clubId: string | null | undefined) => tuple(config, clubId),
  /** QR code do pareamento por gateway de um clube (polling). */
  gatewayQr: (clubId: string | null | undefined) => tuple(root, "gateway-qr", clubId),
} as const;
